import { $ } from '../util/view';
export default function ({ message, onClose = () => { } }) {
    return ($('div', { class: 'mol-ads-cmp--alert' }, [
        $('p', { class: 'mol-ads-cmp--alert-text' }, message),
        $('button', { class: 'mol-ads-cmp--close', type: 'button' }, [
            $('span', {}, ['\u00D7'])
        ]).click(onClose)
    ]));
}
